import { ChartSeriesItem, Series } from "../../Models/ICharts";

export const dataSeries1 = [
    { name: 'Jan', value: 120 },
    { name: 'Feb', value: 132 },
    { name: 'Mar', value: 101 },
    { name: 'Apr', value: 134 },
    { name: 'May', value: 90 },
    { name: 'Jun', value: 230 },
];

export const dataSeries2 = [
    { name: 'Jan', value: 220 },
    { name: 'Feb', value: 182 },
    { name: 'Mar', value: 191 },
    { name: 'Apr', value: 234 },
    { name: 'May', value: 290 },
    { name: 'Jun', value: 330 },
];

export const dataSeries3 = [
    { name: 'Jan', value: 320 },
    { name: 'Feb', value: 332 },
    { name: 'Mar', value: 301 },
    { name: 'Apr', value: 334 },
    { name: 'May', value: 390 },
    { name: 'Jun', value: 430 },
];

export const series1: Series[] = [
    { name: 'Series 1', type: 'bar', data: dataSeries1, smooth: true },
    { name: 'Series 2', type: 'bar', data: dataSeries2, smooth: true },
    { name: 'Series 3', type: 'bar', data: dataSeries3, smooth: true },
];
export const series2: Series[] = [
    { name: 'Series 1', type: 'line', data: dataSeries1, smooth: true },
    { name: 'Series 2', type: 'line', data: dataSeries2, smooth: true },
    { name: 'Series 3', type: 'line', data: dataSeries3, smooth: true },
];
export const series3: Series[] = [
    { name: 'Series 1', type: 'bar', data: dataSeries1, smooth: true },
    { name: 'Series 2', type: 'line', data: dataSeries2, smooth: true },
    { name: 'Series 3', type: 'bar', data: dataSeries3, smooth: true },
];

export const pieData: ChartSeriesItem[] = [
    {
        name: 'Search Engine',
        value: 1048,
    },
    {
        name: 'Direct',
        value: 735,
    },

    {
        name: 'Email',
        value: 580,
    },

    {
        name: 'Union Ads',
        value: 484,
    },
    {
        name: 'Video Ads',
        value: 300,
    }
]